export class AuthorConstant {
  static readonly LOCATION = 'Location';
  static readonly PARTNER = 'Partner';
  static readonly ENTER_ALL_EMAIL_PLACEHOLDER_TEXT = $localize`:@@author.email-placeholder:Enter all email addresses to invite to IPOS Central.`;
  static readonly AUTHOR_USER_ROLE = 'author';
  static readonly SLASH_PARTNER = '/partner';
  static readonly SLASH_PARTNERS = '/partners';
  static readonly PARTNER_NAME_SEARCH_QUERY_PARAMETER = '/?partnernamesearch=';
  static readonly ROLE_AUTHOR_QUERY_PARAMETER = '?role=author';
  static readonly EMAIL = 'email';
  static readonly NAME = 'name';
  static readonly PARTNER_SORT = 'partnerName';
  static readonly LOCATION_SORT = 'location';
  static readonly EMPTY_STRING = '';
  static readonly SORT_BY = 'sortby';
  static readonly SORT_TYPE = 'sorttype';
  static readonly ASCENDING_ORDER = 'asc';
  static readonly DESCENDING_ORDER = 'desc';
  static readonly PARTNER_NAME_SEARCH_PARAMETER = '&partnerNamesearch=';
  static readonly AUTHORS_TAB_DISABLED_MSG = $localize`:@@author.tad-disabled-message:The Authors tab will be disabled until you add a Partner`;
  static readonly AUTHORS_CREATED_TIME_DESC_SORT = '&sortby=updatedTime&sorttype=desc';
  static readonly PAGE_NUMBER_QUERY_PARAM = '&pagenumber=';
  static readonly SEARCH_PLACEHOLDER = $localize`:@@author.search-placeholder:Search by Partner..`
  static readonly ALT_CLOSE = $localize`:@@author.alt-close:CLOSE`
  static readonly ALT_SEARCH = $localize`:@@author.alt-search:SEARCH`
  static readonly ALT_DELETE = $localize`:@@author.alt-delete:DELETE`
  static readonly ALT_NEW_AUTHOR = $localize`:@@author.alt-new-author:NEW AUTHOR`
  static readonly PARTNER_DROPDOWN_SORT_BY = '?sortby=';
  static readonly PARTNER_DROPDOWN_SORT_TYPE = '&sorttype=';
  static readonly UPDATED_TIME = 'updatedTime';
}